(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("babylonjs"), require("babylonjs-serializers"));
	else if(typeof define === 'function' && define.amd)
		define("babylonjs-node-geometry-editor", ["babylonjs", "babylonjs-serializers"], factory);
	else if(typeof exports === 'object')
		exports["babylonjs-node-geometry-editor"] = factory(require("babylonjs"), require("babylonjs-serializers"));
	else
		root["NODEGEOMETRYEDITOR"] = factory(root["BABYLON"], root["BABYLON"]);
})((typeof self !== "undefined" ? self : typeof global !== "undefined" ? global : this), (__WEBPACK_EXTERNAL_MODULE__5597__, __WEBPACK_EXTERNAL_MODULE__513__) => {
return 